var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartStyleLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.84679 6.53657L7.82393 3.85714H9.55707L11.9279 1.18972L11.5005 0.810287L9.3005 3.28572H7.6045L4.86736 5.74914L3.14279 4.02457L0.654785 6.512L1.05936 6.91657L3.14279 4.83257L4.84679 6.53657Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartStyleLine);
export default __webpack_public_path__ + "static/media/chart-style-line.85cbcfacf6dd894182812bbfb7d76357.svg";
export { ForwardRef as ReactComponent };